// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate
// // import ProjectList from './ProjectList';
// import Button from '@mui/material/Button';
// import { Box, Paper } from '@mui/material';
// // import AddIcon from '@mui/icons-material/Add';
// import { Typography } from '@mui/material';
// // import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
// import GroupIcon from '@mui/icons-material/Group';
// import AddIcon from '@mui/icons-material/Add';

// // import NewProject from './NewProject';
// import { useAppDispatch } from '../../app/hooks';
// import { fetchUsers } from '../UserManagement/UserSlice';
// import HomeTiles from '../../components/layout/HomeTiles';
// import Popup from '../Common/PopupFullScreen';
// import TimesheetAction from './components/TimeSheetButton';
// import ShiftNotesButton from './components/ShiftNotesFormButton';
// import CarSafetyCheck from './components/CarSafetyCheckButton';
// import ShiftsRequestsButton from './components/ShiftsRequestButton';
// import PayslipsViewButton from './components/PayslipsViewButton';
// import EditNoteIcon from '@mui/icons-material/EditNote';
// import TaskButton from './TaskButton';
// import StatementView from '../../views/application/crm/SalesManagement/Statement';

// function progressnotes() {
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   useEffect(() => {
//     dispatch(fetchUsers());
//   }, []);

//   const [project, setProject] = useState(null);

//   return (
//     <>
//       <Box display="flex" flexDirection="column" height="100%">
//         {/* <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}> */}
//         {/* <Box display="flex" alignItems="center" width="50%">

//             <Typography
//               className="bold-text"
//               sx={{
                
                
//                 color: 'var(--color-ocean-highlight)',
//                 fontSize: '32px',
              
                
//                 height: '20px',
//                 maxWidth: '100%',
//                 mr: 2,
//                 ml:'20px',
//               }}
//               align="left"
//               variant="h4"
//               gutterBottom
//             >
//               Complete Paper Work Tasks:
//             </Typography>

       
//           </Box > */}

//         {/* <Box display="flex" alignItems="center" width="75%">
//           <Typography
//             className="bold-text"
//             sx={{
//               color: 'var(--color-ocean-highlight)',
//               fontSize: '32px',
//               ml:'10px'
     
//             }}
//             align="left"
//             variant="h3"
//             gutterBottom
//           >
//             Please Read through the client's progress Notes :
//           </Typography>

//           </Box> */}
//         {/* </Box> */}

//         {/* This is creating the main two grey grids*/}

//         <Box sx={{ display: 'flex' }}>
//           <Box sx={{ flexDirection: 'column', mr: '40px', width: '38%', display: 'flex' }}>
//             {/* This making sure that buttons are arranged in a grid */}
//             <Box sx={{ display: 'flex' }}>
//               <Box sx={{ mt: '20px', ml: '30px', flexDirection: 'column' }}>
//                 <TaskButton
//                   label="Active User Cards"
//                   startIcon={<GroupIcon />}
//                   onClick={() => {
//                     navigate('/active-user-cards');
//                   }}
//                 />
//               </Box>
//               <Box sx={{ mt: '20px', ml: '80px' }}>
//                 <TaskButton
//                   label="Membership Applications"
//                   startIcon={<AddIcon />}
//                   onClick={() => {
//                     navigate('/membership-applications-list');
//                   }}
//                 />
//               </Box>
//             </Box>

//             {/* This making sure that buttons are arranged in a grid */}
//             <Box sx={{ display: 'flex' }}>
//               <Box sx={{ mt: '20px', ml: '30px', flexDirection: 'column' }}>
//                 <TaskButton
//                   label="Loan application"
//                   startIcon={<EditNoteIcon />}
//                   onClick={() => {
//                     navigate('/investment-loan-application');
//                   }}
//                 />
//               </Box>
//               <Box sx={{ mt: '20px', ml: '80px' }}>
//                 <TaskButton
//                   label="Membership Applications"
//                   startIcon={<AddIcon />}
//                   onClick={() => {
//                     navigate('/membership-applications-list');
//                   }}
//                 />
//               </Box>
//             </Box>
//           </Box>

//           {/* This box is the greyed box */}
//           <Box
//             sx={{
//               display: 'block',
//               flexDirection: 'column',
//               mr: '40px',
//               backgroundColor: 'var(--color-dark-gray)',
//               width: '80%'
//             }}
//           >
//             <StatementView />
//           </Box>
//         </Box>
//       </Box>
//     </>
//   );
// }

// export default progressnotes;
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import AddIcon from '@mui/icons-material/Add';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useAppDispatch } from '../../app/hooks';
import { fetchUsers } from '../UserManagement/UserSlice';
import TaskButton from './TaskButton';
import StatementView from '../../views/application/crm/SalesManagement/Statement';

function ProgressNotes() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const [project, setProject] = useState(null);

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flexDirection: 'column', mr: '40px', width: '38%', display: 'flex' }}>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ mt: '20px', ml: '30px', flexDirection: 'column' }}>
              <TaskButton
                label="Active User Cards"
                startIcon={<GroupIcon />}
                onClick={() => {
                  navigate('/active-user-cards');
                }}
              />
            </Box>
            <Box sx={{ mt: '20px', ml: '80px' }}>
              <TaskButton
                label="Membership Applications"
                startIcon={<AddIcon />}
                onClick={() => {
                  navigate('/membership-applications-list');
                }}
              />
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ mt: '20px', ml: '30px', flexDirection: 'column' }}>
              <TaskButton
                label="Loan application"
                startIcon={<EditNoteIcon />}
                onClick={() => {
                  navigate('/investment-loan-application');
                }}
              />
            </Box>
            <Box sx={{ mt: '20px', ml: '80px' }}>
              <TaskButton
                label="Membership Applications"
                startIcon={<AddIcon />}
                onClick={() => {
                  navigate('/membership-applications-list');
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'block',
            flexDirection: 'column',
            mr: '40px',
            backgroundColor: 'var(--color-dark-gray)',
            width: '80%',
          }}
        >
          <StatementView />
        </Box>
      </Box>
    </Box>
  );
}

export default ProgressNotes;

